export default "__VITE_ASSET__BRM8dqQ4__"